import { useCallback, useState } from "react";
import { useDataProvider } from "react-admin";
import { SiteModeEnum } from "shared/enums/globalEnums";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";

const useFingridTestGenericInitialForm = () => {
  const dataProvider = useDataProvider();
  const [sitesNotInTestMode, setSitesNotInTestMode] = useState<string[]>([]);

  const fetchSitesData = useCallback(
    async (siteIds: number[]) => {
      if (!siteIds || !siteIds.length) {
        setSitesNotInTestMode([]);
        return;
      }
      try {
        const { data } = await dataProvider.getList(SiteResourcesEnum.Sites, {
          pagination: { page: 1, perPage: 100 },
          filter: { id__in: siteIds.join(",") },
          sort: { field: "id", order: "ASC" },
        });

        const nonTestSites = data
          .filter((site: any) => site.mode !== SiteModeEnum.test)
          .map((site: any) => `${site.id}: ${site.name}`);

        setSitesNotInTestMode(nonTestSites);
      } catch (error) {
        console.error("Error fetching sites data:", error);
        setSitesNotInTestMode([]);
      }
    },
    [dataProvider],
  );
  return { sitesNotInTestMode, fetchSitesData };
};

export default useFingridTestGenericInitialForm;
